<template>
  <v-dialog persistent v-model="dialog" fullscreen>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="$emit('onClose')"><v-icon>close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text
        style="
          height: calc(100vh - 75px - 75px);
          overflow: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-if="isLoading == true"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
      <v-card-text
        style="
          height: calc(100vh - 75px - 75px);
          overflow: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        v-else-if="isCreate || isEdit"
      >
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-card-text>
      <v-card-text
        style="max-height: calc(100vh - 75px - 75px); overflow: auto"
        v-else
      >
        <v-form v-model="valid" ref="formProduct">
          <v-layout wrap>
            <v-flex xs12 sm6 class="pa-3">
              <div
                style="border: 1px solid grey; border-radius: 6px"
                class="pa-2"
              >
                <v-text-field
                  :rules="[
                    rules.required,
                    (v) => v.length <= 55 || 'Character must less then 56',
                  ]"
                  label="Name TH"
                  v-model="form.product_name_th"
                  counter="55"
                ></v-text-field>
                <v-textarea
                  :rules="[
                    rules.required,
                    (v) => v.length <= 255 || 'Character must less then 256',
                  ]"
                  label="Description TH"
                  v-model="form.product_description_th"
                  counter="255"
                ></v-textarea>
              </div> </v-flex
            ><v-flex xs12 sm6 class="pa-3">
              <div
                style="border: 1px solid grey; border-radius: 6px"
                class="pa-2"
              >
                <v-text-field
                  :rules="[
                    rules.required,
                    (v) => v.length <= 55 || 'Character must less then 56',
                  ]"
                  label="Name EN"
                  v-model="form.product_name_en"
                  counter="55"
                ></v-text-field>

                <v-textarea
                  :rules="[
                    rules.required,
                    (v) => v.length <= 255 || 'Character must less then 256',
                  ]"
                  label="Description EN"
                  v-model="form.product_description_en"
                  counter="255"
                ></v-textarea></div></v-flex
          ></v-layout>

          <v-layout wrap>
            <v-flex xs12 sm4 class="pa-3">
              <v-text-field
                :rules="[
                  rules.required,
                  rules.moreThanEqualZero,
                  rules.integer,
                ]"
                label="Price"
                v-model="form.product_base_price"
                type="number"
              ></v-text-field
            ></v-flex>

            <v-flex xs12 sm4 class="pa-3">
              <v-text-field
                prepend-icon="person"
                :rules="[
                  rules.required,
                  (v) => v <= form.product_maximum_person || 'invalid person',
                  rules.moreThanEqualZero,
                  rules.integer,
                ]"
                label="Minimum person"
                v-model="form.product_minimum_person"
                type="number"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm4 class="pa-3">
              <v-text-field
                prepend-icon="person"
                :rules="[
                  rules.required,
                  (v) => v >= form.product_minimum_person || 'invalid person',
                  rules.moreThanEqualZero,
                  rules.integer,
                ]"
                label="Maximum person"
                v-model="form.product_maximum_person"
                type="number"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm4 class="pa-3">
              <v-text-field
                :rules="[
                  rules.required,
                  rules.moreThanEqualZero,
                  rules.integer,
                ]"
                label="Course amount"
                v-model="form.product_course_amount"
                type="number"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm4 class="pa-3">
              <v-text-field
                prepend-icon="schedule"
                :rules="[
                  rules.required,
                  rules.moreThanEqualZero,
                  rules.integer,
                ]"
                label="Time Limit(Minute)"
                v-model="form.time_limit"
                type="number"
              ></v-text-field
            ></v-flex>
            <v-flex xs12 sm4 class="pa-3">
              <v-menu
                ref="menuDate"
                v-model="menuDate"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="form.product_booking_expiration"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.product_booking_expiration"
                    label="Booking Expired Date"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="moment().format('YYYY-MM-DD')"
                  color="black"
                  v-model="form.product_booking_expiration"
                  year-icon="mdi-calendar-blank"
                  prev-icon="mdi-skip-previous"
                  next-icon="mdi-skip-next"
                  @change="$refs.menuDate.save(form.product_booking_expiration)"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <div
            style="border: 2px solid #e9e9e9; border-radius: 6px"
            class="pa-3"
          >
            <div style="display: flex; align-items: center">
              <h4>Discount</h4>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-btn
                icon
                color="primary"
                class="white--text"
                @click="
                  form.discount.push({
                    discount_value: '20',
                    discount_unit: '2',
                    discount_start_date: '2022-12-01',
                    discount_end_date: '2022-12-31',
                  })
                "
              >
                <v-icon dark color="black">add</v-icon>
              </v-btn>
            </div>

            <v-layout wrap class="mt-3">
              <v-flex
                xs12
                sm3
                class="pa-2 ml-4 mt-3"
                v-for="(discount, index) in form.discount"
                :key="`discount-{${index}}`"
              >
                <div style="position: relative">
                  <v-btn
                    icon
                    style="
                      position: absolute;
                      width: 40px;
                      height: 40px;
                      top: -20px;
                      right: -20px;
                      background-color: red;
                      color: white;
                      border-radius: 50%;
                      font-weight: bold;
                      z-index: 1;
                    "
                    @click="form.discount.splice(index, 1)"
                    ><v-icon style="font-size: 18px">delete</v-icon></v-btn
                  >
                  <v-card color="#feff9c">
                    <v-card-text>
                      <v-layout style="display: flex">
                        <v-flex xs8 class="pr-2">
                          <v-text-field
                            v-if="discount.discount_unit == 1"
                            :rules="[
                              rules.required,
                              rules.moreThanEqualZero,
                              rules.integer,
                            ]"
                            v-model="discount.discount_value"
                            type="number"
                          ></v-text-field>
                          <v-text-field
                            v-else
                            :rules="[
                              rules.required,
                              rules.moreThanEqualZero,
                              rules.percentage,
                              rules.integer,
                            ]"
                            v-model="discount.discount_value"
                            type="number"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                          <v-select
                            item-text="name"
                            item-value="value"
                            :items="[
                              { name: '฿', value: '1' },
                              { name: '%', value: '2' },
                            ]"
                            v-model="discount.discount_unit"
                          ></v-select>
                        </v-flex>
                      </v-layout>

                      <v-menu
                        @input="startMenuIndex = index"
                        :value="startMenuIndex == index"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :rules="[
                              rules.required,
                              (v) =>
                                (v != '' &&
                                  moment(v) <=
                                    moment(discount.discount_end_date)) ||
                                'invalid date range',
                            ]"
                            v-model="discount.discount_start_date"
                            label="Start date"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :min="moment().format('YYYY-MM-DD')"
                          color="black"
                          v-model="discount.discount_start_date"
                          year-icon="mdi-calendar-blank"
                          prev-icon="mdi-skip-previous"
                          next-icon="mdi-skip-next"
                          @input="startMenuIndex = -1"
                        ></v-date-picker>
                      </v-menu>
                      <v-menu
                        @input="endMenuIndex = index"
                        :value="endMenuIndex == index"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :rules="[
                              rules.required,
                              (v) =>
                                (v != '' &&
                                  moment(v) >=
                                    moment(discount.discount_start_date)) ||
                                'invalid date range',
                            ]"
                            v-model="discount.discount_end_date"
                            label="End date"
                            prepend-icon="event"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          :min="moment().format('YYYY-MM-DD')"
                          color="black"
                          v-model="discount.discount_end_date"
                          year-icon="mdi-calendar-blank"
                          prev-icon="mdi-skip-previous"
                          next-icon="mdi-skip-next"
                          @input="endMenuIndex = -1"
                        ></v-date-picker>
                      </v-menu>
                    </v-card-text>
                  </v-card>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div
            style="border: 2px solid #e9e9e9; border-radius: 6px"
            class="pa-3 mt-3"
          >
            <div style="display: flex; align-items: center">
              <h4>Menu images</h4>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-btn
                icon
                color="info"
                class="white--text"
                @click="$refs.LogoInput.click()"
              >
                <v-icon dark>cloud_upload</v-icon>
              </v-btn>
              <input
                style="display: none"
                type="file"
                @change="onLogoSelected"
                ref="LogoInput"
                accept="image/*"
              />
              <!-- <span style="color: red">* only jpeg/jpg image</span> -->
            </div>

            <v-layout wrap class="mt-3">
              <v-flex
                xs12
                sm3
                class="pa-2"
                v-for="(image, index) in imageSrc"
                :key="`image_menu_new-{${index}}`"
              >
                <div style="position: relative">
                  <v-btn
                    icon
                    style="
                      position: absolute;
                      width: 50px;
                      height: 50px;
                      top: -20px;
                      right: -20px;
                      background-color: red;
                      color: white;
                      border-radius: 50%;
                      font-weight: bold;
                    "
                    @click="imageSrc.splice(index, 1)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                  <img width="100%" :src="image" alt="" />
                </div>
              </v-flex>
              <v-flex
                xs12
                sm3
                class="pa-2"
                v-for="(image, index) in form.image_menu"
                :key="`image_menu-{${index}}`"
              >
                <div style="position: relative">
                  <v-btn
                    icon
                    style="
                      position: absolute;
                      width: 50px;
                      height: 50px;
                      top: -20px;
                      right: -20px;
                      background-color: red;
                      color: white;
                      border-radius: 50%;
                      font-weight: bold;
                    "
                    @click="form.image_menu.splice(index, 1)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                  <img width="100%" :src="image" alt="" />
                </div>
              </v-flex>
            </v-layout>
          </div>

          <div
            style="border: 2px solid #e9e9e9; border-radius: 6px"
            class="pa-3 mt-3"
          >
            <div style="display: flex; align-items: center">
              <h4>Package images</h4>
              <v-divider class="mx-2" inset vertical></v-divider>
              <v-btn
                icon
                color="info"
                class="white--text"
                @click="$refs.ImageInput.click()"
              >
                <v-icon dark>cloud_upload</v-icon>
              </v-btn>
              <input
                style="display: none"
                type="file"
                @change="onImageSelected"
                ref="ImageInput"
                accept="image/*"
              />
              <span style="color: red">* only jpeg/jpg image</span>
            </div>

            <v-layout wrap class="mt-3">
              <v-flex
                xs12
                sm3
                class="pa-2"
                v-for="(image, index) in packageImageSrc"
                :key="`package_image_new-{${index}}`"
              >
                <div style="position: relative">
                  <v-btn
                    icon
                    style="
                      position: absolute;
                      width: 50px;
                      height: 50px;
                      top: -20px;
                      right: -20px;
                      background-color: red;
                      color: white;
                      border-radius: 50%;
                      font-weight: bold;
                    "
                    @click="packageImageSrc.splice(index, 1)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                  <img width="100%" :src="image" alt="" />
                </div>
              </v-flex>
              <v-flex
                xs12
                sm3
                class="pa-2"
                v-for="(image, index) in form.image"
                :key="`package_image-{${index}}`"
              >
                <div style="position: relative">
                  <v-btn
                    icon
                    style="
                      position: absolute;
                      width: 50px;
                      height: 50px;
                      top: -20px;
                      right: -20px;
                      background-color: red;
                      color: white;
                      border-radius: 50%;
                      font-weight: bold;
                    "
                    @click="form.image.splice(index, 1)"
                    ><v-icon>delete</v-icon></v-btn
                  >
                  <img width="100%" :src="image" alt="" />
                </div>
              </v-flex>
            </v-layout>
          </div>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions style="height: 75px" v-if="isLoading == false">
        <v-spacer></v-spacer>
        <v-btn outline color="red" class="mr-3" :disabled="isCreate || isEdit"
          >reset</v-btn
        >
        <v-btn
          fla
          color="success"
          style="color: black"
          :loading="isCreate || isEdit"
          @click="submit()"
          outline
          >save</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="openSnackbar" color="black" :timeout="3000">
      <v-icon color="error" class="pr-1">close</v-icon>
      ไม่สามารถ {{ editedIndex == -1 ? "เพิ่ม" : "แก้ไข" }} สินค้าได้
      <v-btn icon @click="openSnackbar = false">
        <v-icon color="red">close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="cropImageDialog" max-width="65vw" persistent>
      <v-card>
        <imageCropper
          :aspectRatio="1 / 1"
          :imageName="''"
          :imgSrc="croppedImageSrc"
          :height="300"
          @close="
            cropImageDialog = false;
            croppedImageSrc = null;
          "
          @getCroped="getCroppedImage($event)"
          v-if="croppedImageSrc != null"
        ></imageCropper>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import { mapActions } from "vuex";
import moment from "moment";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import imageCropper from "@/components/Plugins/imageCropper.vue";
export default {
  props: {
    dialog: {},
    editedIndex: {},
    selected_item: {
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      openSnackbar: false,
      isEdit: false,
      isCreate: false,
      isLoading: false,
      start_date: null,
      menuDate: false,
      imageSrc: [],
      packageImageSrc: [],
      form: { discount: [], image_menu: [] },
      startMenuIndex: -1,
      endMenuIndex: -1,
      valid: false,
      rules: {
        required: (value) => value == "0" || !!value || "Required.",
        moreThanEqualZero: (value) =>
          value >= "0" || "Must be more than or equal zero",
        percentage: (value) =>
          (value >= 0 && value <= 100) || "Must be between 0 to 100",
        integer: (value) => {
          const pattern = /^[0-9]\d*$/;
          return pattern.test(value) || "Must be integer";
        },
      },
      cropImageDialog: false,
      croppedImageSrc: null,
    };
  },
  components: {
    VueTimepicker,
    imageCropper,
  },
  watch: {
    async dialog() {
      if (this.dialog == true && this.editedIndex > -1) {
        this.isLoading = true;
        await this.getProductByID();
        this.isLoading = false;
      } else {
        this.resetForm();
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Product" : "Edit Product";
    },
  },
  methods: {
    ...mapActions({
      updateProduct: "fetchDineIn/editProductByID",
      addProduct: "fetchDineIn/createProductDinein",
      fetchProductByID: "fetchDineIn/fetchProductByID",
    }),
    calculateTimeToSec(product_time_limit) {
      let second = 0;
      second += parseInt(product_time_limit.split(":")[0]) * 60 * 60;
      second += parseInt(product_time_limit.split(":")[1]) * 60;
      second += parseInt(product_time_limit.split(":")[2]);
      return second;
    },
    async getProductByID() {
      let result = await this.fetchProductByID(this.selected_item.product_id);
      this.form = JSON.parse(JSON.stringify(result));
      if (this.form.product_booking_expiration != null) {
        this.form.product_booking_expiration = moment(
          result.product_booking_expiration
        ).format("YYYY-MM-DD");
      }
      this.form.discount = result.discount.map((val) => {
        return {
          discount_value: val.discount_value,
          discount_unit: val.discount_unit,
          discount_start_date: moment(val.discount_start_date).format(
            "YYYY-MM-DD"
          ),
          discount_end_date: moment(val.discount_end_date).format("YYYY-MM-DD"),
        };
      });
      if (result.product_time_limit != null) {
        this.form.time_limit = this.calculateTimeToSec(
          result.product_time_limit
        );
      } else {
        this.form.time_limit = 0;
      }
      return;
    },
    resetForm() {
      this.form = {
        product_name_th: "เซ็ทเลือกได้ 4 เมนูสำหรับ 3 ท่าน",
        product_name_en: "Sharing Set For 3 Person : Choose 4 Dishes",
        product_base_price: 899,
        product_course_amount: 4,
        product_minimum_person: 1,
        product_maximum_person: 4,
        product_description_th:
          "เซ็ทเลือกได้ 4 เมนูสำหรับ 3 ท่านเช่น ปลาทอดน้ำปลา กุ้งผัดพริกไทยดำ เป็นต้นและรายการอื่นๆอีกมากมาย พร้อมเครื่องดื่มNon Alcohol Drink ไม่อั้น!",
        product_description_en:
          "Choose 4 Dishes for 3 Person Such as Fried Fish with Fish Sauce, Fried Shrimp with Black Pepper and More Menus with Free Flow Non Alcohol Drink",
        product_booking_expiration: null,
        product_status: true,
        product_store_id: this.$route.params.store_id,
        image_menu: [],
        discount: [
          {
            discount_value: 50,
            discount_unit: "1",
            discount_start_date: moment().format("YYYY-MM-DD"),
            discount_end_date: moment().format("YYYY-MM-DD"),
          },
          {
            discount_value: 10,
            discount_unit: "2",
            discount_start_date: moment().format("YYYY-MM-DD"),
            discount_end_date: moment().format("YYYY-MM-DD"),
          },
        ],
        time_limit: 0,
        image: [],
      };
      this.imageSrc = [];
      this.packageImageSrc = [];
    },
    onLogoSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imageSrc.push(reader.result);
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.cropImageDialog = true;
        this.croppedImageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    getCroppedImage(image) {
      this.packageImageSrc.push(image);
      this.cropImageDialog = false;
      this.croppedImageSrc = null;
    },
    submit() {
      if (!this.$refs.formProduct.validate()) return;
      if (this.editedIndex == -1) {
        this.createProduct();
      } else {
        this.editProduct();
      }
    },
    async createProduct() {
      this.isCreate = true;
      let result = await this.addProduct({
        form: this.form,
        imageSrc: this.imageSrc,
        packageImageSrc: this.packageImageSrc,
      });
      this.isCreate = false;
      if (result == false) return (this.openSnackbar = true);
      this.$emit("onSaved");
    },
    async editProduct() {
      this.isEdit = true;
      let result = await this.updateProduct({
        form: this.form,
        imageSrc: this.imageSrc,
        packageImageSrc: this.packageImageSrc,
      });
      this.isEdit = false;
      if (result == false) return (this.openSnackbar = true);
      this.$emit("onSaved");
    },
  },
};
</script>

<style scoped></style>
